import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Locate } from "../../models/locate";
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }


  lookup(locate: Locate) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "p1": locate.drugName
      })
    };

    return this.http.get(this.baseUrl + "lookup/creds/", httpOptions);
  }
}
